import { React, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Summary from './Summary';
import { strings } from '../localization/strings';

function PersonalDataInput({nextStep, availability, tourName, date, adult, child, baby, requestAllDetails, language, excludeFree}) {

    const initFormData = () => {
        if (location.state) {
            const expectedLength = requestAllDetails ? parseInt(adult) + parseInt(child) + parseInt(baby) : 1;
            if (location.state.formData && location.state.formData.length === expectedLength) {
                return location.state.formData;
            }
        }
        return requestAllDetails ? Array.from({ length: passengers }, () => ({})) : [{}];
    }
    
    const location = useLocation();
    const passengers = parseInt(adult) + parseInt(child) + parseInt(baby);
    const [formData, setFormData] = useState(initFormData());
    const [invoiceData, setInvoiceData] = useState(location.state?.invoiceData || {});
    const [validationErrorInvoice, setValidationErrorInvoice] = useState(undefined);

    const translation = strings[language] ?? strings.it;

    
    const handleChangeInvoice = (e) => {
        const { name, value } = e.target;
        setInvoiceData({
            ...invoiceData,
            [name]: value
        });
    };

    const handleChange = (index, e) => {
        const { name, value } = e.target;
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [name]: value
        };
        setFormData(updatedFormData);
    };

    const clickNextStep = () => {
        if (validateForm()) {
            nextStep(formData, invoiceData);
        } else {
            setFormData([...formData]);
            setInvoiceData({ ...invoiceData });
        }
    };

    const validateForm = () => {
        for (let i = 0; i < formData.length; i++) {
            const data = formData[i];
            let formValid = data.first_name && data.last_name && (!requestAllDetails || data.birthday);
            if (i === 0) {
                formValid = formValid && data.email && data.phone;
            }

            if (!formValid) {
                data.validationError = translation.validationErrorFillFields;
                return false;
            } else {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (i === 0 && !emailPattern.test(data.email)) {
                    data.validationError = translation.validationErrorValidEmail;
                    return false;
                } else {
                    const birthdayPattern = /^\d{2}\/\d{2}\/\d{4}$/;
                    if (requestAllDetails && !birthdayPattern.test(data.birthday)) {
                        data.validationError = translation.validationErrorBirthDay;
                        return false;
                    } else {
                        data.validationError = undefined;
                    }
                }
            }
        }
        if (invoiceData.invoiceRequest) {
            const formValidInvoice = invoiceData.ragioneSociale && invoiceData.partitaIva && invoiceData.codiceFiscale && invoiceData.sedeLegale && invoiceData.codiceDestinatario;
            if (!formValidInvoice) {
                setValidationErrorInvoice(translation.validationErrorFillInvoiceFields);
                return false;
            } else {
                setValidationErrorInvoice(undefined);
            }
        }
        return true;
    };

    // init formData
    useEffect(() => {
        if (location.state) {
            const expectedLength = requestAllDetails ? parseInt(adult) + parseInt(child) + parseInt(baby) : 1;
            if (location.state.formData && location.state.formData.length === expectedLength) {
                return;
            }
        }
        const defaultForm = {
            first_name: '',
            last_name: '',
            email: '',
            phone: ''
        }
        setInvoiceData({
            invoiceRequest: false,
            ragioneSociale: '',
            partitaIva: '',
            codiceFiscale: '',
            sedeLegale: '',
            codiceDestinatario: ''
        });
        if (requestAllDetails) {
            setFormData(Array.from({ length: parseInt(adult) + parseInt(child) + parseInt(baby) }, () => ({ ...defaultForm })));
        } else {
            setFormData([defaultForm]);
        }
    }, [location.state, requestAllDetails, adult, child, baby]);

    const tooltipStyleInt = {
        position: 'absolute',
        zIndex: '9999',
        background: '#000',
        padding: '10px',
        borderRadius: '3px',
        font: 'Jost, sans-serif',
        fontSize: '14px',
        color: '#fff',
        maxWidth: '300px'
    };

    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipStyle, setTooltipStyle] = useState({});

    const handleMouseEnter = () => {
        const tooltipElement = document.querySelector('.fa-circle-info');
        const header = document.querySelector('.tourmaster-payment-head');
        if (tooltipElement) {
            const rect = tooltipElement.getBoundingClientRect();
            const headerRect = header.getBoundingClientRect();
            tooltipStyleInt.left = `${rect.left - 90 + window.scrollX}px`;
            tooltipStyleInt.top = `${rect.top - headerRect.height -80 + window.scrollY}px`;
            
            setTooltipStyle(tooltipStyleInt);
        }
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    

    return (
        <div>
            <div className="tourmaster-tour-payment-content" id="tourmaster-tour-payment-content">
            { !requestAllDetails &&
                <div className="tourmaster-form-field tourmaster-with-border">
                    <h5 style={{color: '#a3a3a3', display: 'inline'}}>{translation.yourData}:
                    </h5>
                    <span className="fa fa-solid fa-circle-info" style={{color: '#00a1a3', top: '-10px', marginLeft: '5px'}}
                        onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}></span>
                    {showTooltip && <div style={{ ...tooltipStyle }}>{translation.tooltipDataFromOnePassenger}</div>}
                    <div className="personal-data-container">
                        <div style={{display: 'flex', flexWrap: 'wrap'}}>
                            <div className="personal-data-container-column">
                                <input style={{backgroundColor: '#fff'}} placeholder={translation.name + '*'} type="text" name="first_name"
                                        data-required="" onChange={(e) => handleChange(0, e)} value={formData[0].first_name || ''} />
                                <input style={{backgroundColor: '#fff'}} placeholder={translation.surname + '*'} type="text" name="last_name" onChange={(e) => handleChange(0, e)} value={formData[0].last_name || ''}
                                        data-required="" />
                            </div>
                            <div className="personal-data-container-column">
                                <input style={{backgroundColor: '#fff', marginRight: '0px'}} placeholder={translation.email + '*'} type="email" name="email" onChange={(e) => handleChange(0, e)} value={formData[0].email || ''}
                                            data-required="" />
                                
                                <input style={{backgroundColor: '#fff', marginRight: '0px'}} placeholder={translation.phone + '*'} type="text" name="phone" onChange={(e) => handleChange(0, e)} value={formData[0].phone || ''} data-required="" />
                            </div>
                        </div>
                        <textarea style={{backgroundColor: '#fff', resize: 'vertical'}} placeholder={translation.orderNotes}
                            name="additional_notes" onChange={(e) => handleChange(0, e)} value={formData[0].additional_notes || ''}></textarea>
                        <div style={{display: (formData[0].validationError ? 'block' : 'none'), color: '#fe3956', marginTop: '20px'}}>
                            <span className="fa fa-regular fa-circle-xmark"></span>
                            <div className="tour-booking-submit-error">{formData[0].validationError}</div>
                        </div>
                    </div>
                </div>}
                { requestAllDetails && 
                Array.from({ length: parseInt(adult) + parseInt(child) + parseInt(baby) }).map((_, index) => (
                    <div className="tourmaster-form-field tourmaster-with-border">
                        <h5 style={{color: '#a3a3a3'}}>{translation.travelerData} {index + 1}:</h5>
                        <div key={`adult-${index}`} className="personal-data-container">
                            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                <div className="personal-data-container-column">
                                    <input style={{backgroundColor: '#fff'}} placeholder={translation.name + '*'} type="text" name="first_name"
                                        data-required="" onChange={(e) => handleChange(index, e)} value={formData[index].first_name || ''} />
                                    <input style={{backgroundColor: '#fff'}} placeholder={translation.surname + '*'} type="text" name="last_name" onChange={(e) => handleChange(index, e)} value={formData[index].last_name || ''}
                                                data-required="" />
                                    { !index && <div className="personal-data-container-filler"/> }
                                </div>
                                <div className="personal-data-container-column">
                                <input style={{backgroundColor: '#fff', marginRight: '0px'}} placeholder={translation.birthDayWithFormat + '*'} type="text" name="birthday" onChange={(e) => handleChange(index, e)} value={formData[index].birthday || ''} data-required="" />
                                    { !index && <input style={{backgroundColor: '#fff', marginRight: '0px'}} placeholder={translation.email + '*'} type="email" name="email" onChange={(e) => handleChange(index, e)} value={formData[index].email || ''}
                                            data-required="" /> }
                                    { !index && <input style={{backgroundColor: '#fff', marginRight: '0px'}} placeholder={translation.phone + '*'} type="text" name="phone" onChange={(e) => handleChange(index, e)} value={formData[index].phone || ''} data-required="" /> }
                                    
                                </div>
                                { !index && <textarea style={{backgroundColor: '#fff', resize: 'vertical'}} placeholder={translation.orderNotes}
                                            name="additional_notes" onChange={(e) => handleChange(index, e)} value={formData[index].additional_notes || ''}></textarea> }
                            </div>
                            <div style={{display: (formData[index].validationError ? 'block' : 'none'), color: '#fe3956', marginTop: '20px'}}>
                                <span className="fa fa-regular fa-circle-xmark"></span>
                                <div className="tour-booking-submit-error">{formData[index].validationError}</div>
                            </div>
                        </div>
                    </div>
                ))}
                <div>
                    <span className="tourmaster-payment-billing-title" onClick={() => { setInvoiceData(invoiceData => ({ ...invoiceData, invoiceRequest: !invoiceData.invoiceRequest }));}} style={{cursor: 'pointer', color: '#a3a3a3'}}><input type="checkbox"
                    style={{marginRight: '10px', cursor: 'pointer'}} checked={invoiceData.invoiceRequest || false} />{translation.needInvoice}</span>
                    { invoiceData.invoiceRequest && 
                    <div className="tourmaster-form-field tourmaster-with-border" style={{marginTop: '20px'}}>
                        <h5 style={{color: '#a3a3a3'}}>{translation.invoiceData}:</h5>
                        <div className="personal-data-container">
                            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                <div className="personal-data-container-column">
                                    <input style={{backgroundColor: '#fff'}} placeholder={translation.businessName + '*'} type="text" name="ragioneSociale"
                                        data-required="" onChange={handleChangeInvoice} value={invoiceData.ragioneSociale || ''} />
                                    <input style={{backgroundColor: '#fff'}} placeholder={translation.vat + '*'} type="text" name="partitaIva" onChange={handleChangeInvoice} value={invoiceData.partitaIva || ''}
                                        data-required="" />
                                    <input style={{backgroundColor: '#fff'}} placeholder={translation.fiscalCode + '*'} type="text" name="codiceFiscale" onChange={handleChangeInvoice} value={invoiceData.codiceFiscale || ''} data-required="" />
                                </div>
                                <div className="personal-data-container-column">
                                    <input style={{backgroundColor: '#fff'}} placeholder={translation.registeredOffice + '*'} type="text" name="sedeLegale" onChange={handleChangeInvoice} value={invoiceData.sedeLegale || ''}
                                        data-required="" />
                                    <input style={{backgroundColor: '#fff'}} placeholder={translation.recipientCode + '*'} type="text" name="codiceDestinatario" onChange={handleChangeInvoice} value={invoiceData.codiceDestinatario || ''} data-required="" />
                                    <div className="personal-data-container-filler"/>
                                </div>
                            </div>
                            <div style={{display: (validationErrorInvoice ? 'block' : 'none'), color: '#fe3956', marginTop: '20px', width: '100%'}}>
                                <span className="fa fa-regular fa-circle-xmark"></span>
                                <div className="tour-booking-submit-error">{validationErrorInvoice}</div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <Summary availability={availability} tourName={tourName} date={date} adult={adult} child={child} baby={baby} nextStep={clickNextStep} language={language} excludeFree={excludeFree}/>
        </div>
    );
}

export default PersonalDataInput;
